const showWarningMessage = (
    tradingOnHold,
    strategyChange,
    monthlyRebalancing,
) => {
    return (
        (!tradingOnHold && !strategyChange && !monthlyRebalancing) ||
        (tradingOnHold && !strategyChange && !monthlyRebalancing) ||
        (tradingOnHold && !strategyChange && monthlyRebalancing) ||
        (tradingOnHold && strategyChange && !monthlyRebalancing)
    );
};

const getPorfolioOperationStatus = (
    tradingOnHold,
    strategyChange,
    monthlyRebalancing,
) => {
    let operationStatus;
    if (!tradingOnHold && !strategyChange && !monthlyRebalancing) {
        operationStatus = 'NoOrdersNoRebalancing';
    }
    if (tradingOnHold && !strategyChange && !monthlyRebalancing) {
        operationStatus = 'OrderInProgress';
    }
    if (tradingOnHold && !strategyChange && monthlyRebalancing) {
        operationStatus = 'RebalancingByCommittee';
    }
    if (tradingOnHold && strategyChange && !monthlyRebalancing) {
        operationStatus = 'StrategyChangeInProgress';
    }
    return operationStatus;
};

module.exports = { showWarningMessage, getPorfolioOperationStatus };
